import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * Use Shared-Asset  Hook
 */
export default () => {
    const { auditAssetId } = useParams();
    const { auditAssets } = useSelector((state) => state);
    const isSharedAsset = useMemo(() => {
        return auditAssets.data.find(
            (item) =>
                item.id === parseInt(auditAssetId) && item.sharedValidationAsset
        );
    }, [auditAssets, auditAssetId]);

    return isSharedAsset;
};
